
export enum TypeOfValidation {
  SMS = "SMS",
  EMAIL = "CORREO",
  WHATSAP = "Whatsapp",
  DEFAULT = "DEFAULT", // SOLO ES PARA VALIDACION DE NIP
  NONE = "NONE"
  }

  export enum IncodeStatus {
    ONBOARDING_FINISHED = "ONBOARDING_FINISHED",
    ERROR_SUSCRIBE = "ERROR_SUSCRIBE"
  }
